module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('h3', [_vm._v("Get in touch with us")]), _vm._v(" "), _c('p', [_vm._v("We love to hear from our members. Please drop us a line if you need any help or have any comments for us. We appreciate all the input!")]), _vm._v(" "), (_vm.errors.any()) ? _c('div', {
    attrs: {
      "id": "feedback"
    }
  }, [(_vm.errors.has('name')) ? _c('p', {
    staticClass: "error wrong_name error-box"
  }, [_vm._v("\n          Please enter your name\n        ")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('email')) ? _c('p', {
    staticClass: "error wrong_email error-box"
  }, [_vm._v("\n          Please enter a valid email\n        ")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('message')) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v("\n          Please enter your message\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.success) ? _c('form', {
    attrs: {
      "id": "contact_us"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.send($event)
      }
    }
  }, [_c('p', {
    staticClass: "label_name"
  }, [_vm._v("\n          Name\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "input_form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.name),
      expression: "contact.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "name",
      "data-vv-delay": "1000"
    },
    domProps: {
      "value": _vm._s(_vm.contact.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "label_name"
  }, [_vm._v("\n          Email\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "input_form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.from),
      expression: "contact.from"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "data-vv-delay": "1000"
    },
    domProps: {
      "value": _vm._s(_vm.contact.from)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.from = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "label_name"
  }, [_vm._v("\n          Message\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "input_form",
    attrs: {
      "id": "textarea"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.message),
      expression: "contact.message"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "id": "message_input",
      "name": "message",
      "rows": "3",
      "cols": "4",
      "data-vv-delay": "1000"
    },
    domProps: {
      "value": _vm._s(_vm.contact.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "label_name"
  }), _vm._v(" "), _c('p', {
    staticClass: "input_form"
  }, [_c('vue-recaptcha', {
    attrs: {
      "sitekey": "6LcSWxkUAAAAABKb28GRtkDtDTTv6bOSJeWr4k5p"
    },
    on: {
      "verify": _vm.onVerify
    }
  })], 1), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "success-box",
    attrs: {
      "id": "success"
    }
  }, [_vm._v("\n        Your message was sent succesfully! "), _c('span', {
    staticClass: "close"
  }, [_vm._v("x")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "1950798677",
      "ad-style": "display:inline-block;width:468px;height:60px",
      "ad-format": "auto"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "1950798677",
      "ad-style": "display:inline-block;width:468px;height:60px",
      "ad-format": "auto"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('ul', [_vm._m(1), _vm._v(" "), _c('testimonial', {
    attrs: {
      "test": _vm.testimonial
    }
  }), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "7997332272",
      "ad-style": "display:inline-block;width:250px;height:250px",
      "ad-format": "auto"
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    attrs: {
      "id": "submit"
    }
  }, [_c('input', {
    staticClass: "big-btn special",
    attrs: {
      "type": "submit",
      "value": "Send Message",
      "name": "submitButton"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "widget"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h5', [_vm._v("Contact Info")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "sprite stsblue1"
  }), _vm._v(" "), _c('p', [_c('strong', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Email:")]), _vm._v(" support@stumpthespread.com"), _c('br')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6e0e6596!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Contact.vue
// module id = 512
// module chunks = 1